export default {
  solutions: {
    breadcrumbHome: 'Početna',
    breadcrumbCurrent: 'Rješenja',
    hero: {
      eyebrow: 'Rješenja',
      title: 'Pravo rješenje za svaki objekt',
      lead: 'Bilo da se radi o privatnoj kući, prodajnom prostoru ili skladištu – zajedno pronalazimo optimalan sustav kamera za vaše potrebe.',
    },
    grid: {
      eyebrow: 'Rješenja za objekte na prvi pogled',
      title: 'Šest područja – jedno obećanje: stvarna sigurnost',
      lead: 'Svaka kartica vodi do zasebnog pregleda s tipičnim točkama nadzora i odgovarajućim tehničkim rješenjima.',
    },
    tag: { privat: 'Privatno', gewerbe: 'Poslovno', innen: 'Unutra', außen: 'Vani', neu: 'Novo', erweiterung: 'Proširenje' },
    more: 'Saznajte više',
    cta: {
      title: 'Niste sigurni koje rješenje odgovara?',
      lead: 'Zajedno analiziramo vaš objekt i preporučujemo pravu kombinaciju kamera, snimanja i opreme.',
      primary: 'Savjetovanje bez obveze',
      secondary: 'Pokrenite planer kamera',
    },
  },
};